<template>
	<div class="account">
		<div class="bind-area">
			<div class="btnbox">
				<el-button type="primary" size="small" @click="onjst()">绑定聚水潭账号(只能绑定1个)</el-button>
			</div>
			<div class="auth-tip">
				授权说明：授权时请选择【主仓授权】（不选择任何分仓），系统才能同步账号下的全部仓库；若选择分仓授权，渠道配置中只能使用 1 个仓库。
			</div>
		</div>
		
		<div class="tablebox">
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="coid" label="公司编号" fixed="left" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="Token状态" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.is_expire == 0" class="token-status ok">未过期</div>
							<div v-if="scope.row.is_expire == 1" class="token-status expired">已过期</div>
						</template>
					</el-table-column>
					<el-table-column label="Token到期时间" align="center" header-align="center">
						<template slot-scope="scope">
							<div>
								{{scope.row.expire_time_str}}
								<span
									v-if="needReauthSoon(scope.row)"
									class="cell-link warn" @click="onjst()">
									即将到期，点击重新授权
								</span>
								<span
									v-if="scope.row.is_expire == 1"
									class="cell-link danger" @click="onjst()">
									已过期，请重新授权
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="绑定时间" align="center" header-align="center" fixed="right">
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		<!-- 公司编号 coid
		token状态 is_expire 0未过期 1已过期
		token到期时间 expire_time_str
		绑定时间 create_time_str -->
	</div>
</template>

<script>
	export default {
		name: 'jstaccount',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
			}
		},
		
		mounted() {
			this.onlist();
		},
		
		methods: {
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			onjst() {
				this.$axios.get('api/jst/auth_url').then(res => {
					if (res.data.code == 0) {
						window.open(res.data.data.url, '_blank');
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			needReauthSoon(row) {
				if (!row || row.is_expire != 0) {
					return false
				}
				if (row.expire_time == null || row.expire_time === '') {
					return false
				}
				var nowTs = Math.floor(Date.now() / 1000)
				return row.expire_time - nowTs <= 15 * 86400
			},
			
			onlist() {
				var obj = {};
				obj.page = this.page;
				obj.limit = this.pageSize;
					
				this.$axios.post('api/jst/account_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.account {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 140px);
	}

	.bind-area {
		margin-bottom: 16px;

		.btnbox {
			margin-bottom: 8px;
		}
	}

	.auth-tip {
		color: #909399;
		font-size: 12px;
		line-height: 1.6;
		text-align: right;
	}

	.cell-link.warn {
		color: #E6A23C;
		cursor: pointer;
		margin-left: 8px;
	}

	.cell-link.danger {
		color: #F56C6C;
		cursor: pointer;
		margin-left: 8px;
	}

	.token-status.ok {
		color: #67C23A;
	}

	.token-status.expired {
		color: #F56C6C;
	}
</style>



// WEBPACK FOOTER //
// src/components/jushuitan/account.vue